module.exports = __webpack_public_path__ + "static/media/academy_icon_yellow.29fbb3cc.svg";